module.exports = __webpack_public_path__ + "img/c5201704-2.c3e23475.jpg";